import { useState } from 'react'
import { useIntl } from 'react-intl'
import Container from 'react-bootstrap/Container'

import ButtonCinestar from '../../../../../../../../components/Buttons/ButtonCinestar/ButtonCinestar'
import InfoWindow from '../../../../../../../../components/Windows/InfoWindow/InfoWindow'
import OverviewTable from './components/OverviewTable/OverviewTable'
import useScroll from '../../../../../../hooks/useScroll'

import './ClubSummaryOverview.scss'

const resultsPerLoad = 9

const ClubSummaryOverview = ({ sectionRef, transactions, points }) => {
    const intl = useIntl()
    const [resultsCount, setResultsCount] = useState(resultsPerLoad)
    const cinestarClubScroll = useScroll(sectionRef, 'start')

    const resultsData = [...transactions].reverse().slice(0, resultsCount)

    return (
        <Container fluid className="club-summary-overview d-flex flex-column">
            <InfoWindow
                color={'white'}
                title={intl.formatMessage({ id: 'global.currency.points' }, { points })}
                description={intl.formatMessage({ id: 'userProfile.cinestarClub.pointsOverview.currentStatus' })}
            />
            {transactions.length > 0 && <OverviewTable data={resultsData} />}
            {transactions.length > 0 && transactions.length > resultsData.length && (
                <ButtonCinestar
                    onClick={() => setResultsCount((currResults) => currResults + resultsPerLoad)}
                    variant={'secondary'}
                    className={'mx-auto'}
                >
                    {intl.formatMessage({ id: 'userProfile.cinestarClub.pointsOverview.loadMore' })}
                </ButtonCinestar>
            )}
            {transactions.length > resultsPerLoad && transactions.length === resultsData.length && (
                <ButtonCinestar
                    onClick={() => {
                        setResultsCount(resultsPerLoad)
                        cinestarClubScroll()
                    }}
                    variant={'secondary'}
                    className={'mx-auto px-5'}
                >
                    {intl.formatMessage({ id: 'buttons.back' })}
                </ButtonCinestar>
            )}
        </Container>
    )
}

export default ClubSummaryOverview
